var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnArrow = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16L13.5714 10L19.1429 16",
    stroke: "currentStroke",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/btnArrow.5c05b61019d0b03a25ba3c437b737ad0.svg";